import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-6" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0 bg-white" }
const _hoisted_4 = { class: "card-header" }
const _hoisted_5 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_6 = { class: "table table-borderless" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 3 }
const _hoisted_11 = { key: 4 }
const _hoisted_12 = { key: 5 }
const _hoisted_13 = { key: 6 }
const _hoisted_14 = { key: 7 }
const _hoisted_15 = { key: 8 }
const _hoisted_16 = { key: 9 }
const _hoisted_17 = { key: 10 }
const _hoisted_18 = { key: 11 }
const _hoisted_19 = { key: 12 }
const _hoisted_20 = { key: 13 }
const _hoisted_21 = { key: 14 }
const _hoisted_22 = { key: 15 }
const _hoisted_23 = { key: 16 }
const _hoisted_24 = { key: 17 }
const _hoisted_25 = { key: 18 }
const _hoisted_26 = { key: 19 }
const _hoisted_27 = { key: 20 }
const _hoisted_28 = { key: 21 }
const _hoisted_29 = { key: 22 }
const _hoisted_30 = { key: 23 }
const _hoisted_31 = { key: 24 }
const _hoisted_32 = { key: 25 }
const _hoisted_33 = { class: "col-md-6" }
const _hoisted_34 = { class: "card mb-25 border-0 rounded-0 bg-white" }
const _hoisted_35 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_36 = { class: "table-responsive" }
const _hoisted_37 = { class: "table card-table table-vcenter text-nowrap" }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { class: "table table-sm table-borderless" }
const _hoisted_40 = { key: 1 }
const _hoisted_41 = { class: "col-md-6" }
const _hoisted_42 = { class: "card mb-25 border-0 rounded-0 bg-white" }
const _hoisted_43 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_44 = { class: "table-responsive" }
const _hoisted_45 = { class: "table card-table table-vcenter text-nowrap" }
const _hoisted_46 = { class: "col-md-6" }
const _hoisted_47 = { class: "card mb-25 border-0 rounded-0 bg-white" }
const _hoisted_48 = { class: "card-header" }
const _hoisted_49 = { style: {"float":"right"} }
const _hoisted_50 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_51 = { class: "table-responsive" }
const _hoisted_52 = { class: "table card-table table-vcenter text-nowrap" }
const _hoisted_53 = { key: 0 }
const _hoisted_54 = { class: "list-unstyled" }
const _hoisted_55 = { key: 1 }
const _hoisted_56 = { key: 0 }
const _hoisted_57 = { class: "list-unstyled" }
const _hoisted_58 = { key: 1 }
const _hoisted_59 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AddRapportModal = _resolveComponent("AddRapportModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "card-title mb-0" }, "Informations du client", -1)),
            _createVNode(_component_router_link, {
              to: "/clients/liste-clients",
              class: "btn btn-primary transition border-0 lh-1 fw-medium",
              style: {"position":"absolute","right":"10px","top":"10px"}
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createElementVNode("i", { class: "flaticon-left-arrow lh-1 me-1 position-relative top-2" }, null, -1),
                _createElementVNode("span", { class: "position-relative" }, "Retour", -1)
              ])),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("table", _hoisted_6, [
              _createElementVNode("tbody", null, [
                (_ctx.client?.statut)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                      _cache[3] || (_cache[3] = _createElementVNode("td", { class: "fw-medium" }, "Statut :", -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.client.statut == 1 ? 'Personne physique' : 'Personne morale'), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.client?.nomClient)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
                      _cache[4] || (_cache[4] = _createElementVNode("td", { class: "fw-medium" }, "Nom :", -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.client.nomClient), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.client?.prenomClient)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                      _cache[5] || (_cache[5] = _createElementVNode("td", { class: "fw-medium" }, "Prénom :", -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.client.prenomClient), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.client?.paysResidence)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                      _cache[6] || (_cache[6] = _createElementVNode("td", { class: "fw-medium" }, "Pays de résidence :", -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.client.paysResidence), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.client?.quartier)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
                      _cache[7] || (_cache[7] = _createElementVNode("td", { class: "fw-medium" }, "Quartier :", -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.client.quartier?.libelle), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.client?.region)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
                      _cache[8] || (_cache[8] = _createElementVNode("td", { class: "fw-medium" }, "Region :", -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.client.region), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.client?.ville)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
                      _cache[9] || (_cache[9] = _createElementVNode("td", { class: "fw-medium" }, "Ville de résidence :", -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.client.ville), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.client?.adresseClient)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                      _cache[10] || (_cache[10] = _createElementVNode("td", { class: "fw-medium" }, "Adresse :", -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.client.adresseClient), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.client?.emailClient)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                      _cache[11] || (_cache[11] = _createElementVNode("td", { class: "fw-medium" }, "Email :", -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.client.emailClient), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.client?.telephone1)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [
                      _cache[12] || (_cache[12] = _createElementVNode("td", { class: "fw-medium" }, "Téléphone 1 :", -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.client.telephone1), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.client?.telephone2)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_17, [
                      _cache[13] || (_cache[13] = _createElementVNode("td", { class: "fw-medium" }, "Téléphone 2 :", -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.client.telephone2), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.client?.dateNais)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [
                      _cache[14] || (_cache[14] = _createElementVNode("td", { class: "fw-medium" }, "Date de naissance :", -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.format_Date(_ctx.client.dateNais)), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.client?.piece?.libelle)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [
                      _cache[15] || (_cache[15] = _createElementVNode("td", { class: "fw-medium" }, "Type de pièce :", -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.client?.piece?.libelle), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.client?.numeroPiece)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_20, [
                      _cache[16] || (_cache[16] = _createElementVNode("td", { class: "fw-medium" }, "Numéro de la pièce :", -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.client.numeroPiece), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.client?.dateExpiration)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_21, [
                      _cache[17] || (_cache[17] = _createElementVNode("td", { class: "fw-medium" }, "Date d'expiration :", -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.client.dateExpiration), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.client?.raisonSociale)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_22, [
                      _cache[18] || (_cache[18] = _createElementVNode("td", { class: "fw-medium" }, "Raison sociale :", -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.client.raisonSociale), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.client?.sigle)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_23, [
                      _cache[19] || (_cache[19] = _createElementVNode("td", { class: "fw-medium" }, "Sigle :", -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.client.sigle), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.client?.ifu)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_24, [
                      _cache[20] || (_cache[20] = _createElementVNode("td", { class: "fw-medium" }, "IFU :", -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.client.ifu), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.client?.dateCreation)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_25, [
                      _cache[21] || (_cache[21] = _createElementVNode("td", { class: "fw-medium" }, "Date de création :", -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.format_Date(_ctx.client.dateCreation)), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.client?.personneAContacter)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_26, [
                      _cache[22] || (_cache[22] = _createElementVNode("td", { class: "fw-medium" }, "Nom et Prénom de la personne à contacter :", -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.client.personneAContacter), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.client?.telephonePersonneAContacter)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_27, [
                      _cache[23] || (_cache[23] = _createElementVNode("td", { class: "fw-medium" }, "Téléphone de la personne à contacter :", -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.client.telephonePersonneAContacter), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.client?.personneRepresentant)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_28, [
                      _cache[24] || (_cache[24] = _createElementVNode("td", { class: "fw-medium" }, "Nom et prénoms du représentant :", -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.client.personneRepresentant), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.client?.telephoneRepresentant)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_29, [
                      _cache[25] || (_cache[25] = _createElementVNode("td", { class: "fw-medium" }, "Téléphone du représentant :", -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.client.telephoneRepresentant), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.client?.rccm)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_30, [
                      _cache[26] || (_cache[26] = _createElementVNode("td", { class: "fw-medium" }, "Régistre de commerce :", -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.client.rccm), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.client?.gerant?.nomClient && _ctx.client?.gerant?.prenomClient)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_31, [
                      _cache[27] || (_cache[27] = _createElementVNode("td", { class: "fw-medium" }, "Gérant :", -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.client?.gerant?.nomClient) + " " + _toDisplayString(_ctx.client?.gerant?.prenomClient), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.client?.promoteur?.nomClient && _ctx.client?.promoteur?.prenomClient)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_32, [
                      _cache[28] || (_cache[28] = _createElementVNode("td", { class: "fw-medium" }, "Promoteur :", -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.client.promoteur.nomClient) + " " + _toDisplayString(_ctx.client.promoteur.prenomClient), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("div", _hoisted_34, [
          _cache[31] || (_cache[31] = _createElementVNode("div", { class: "card-header" }, [
            _createElementVNode("h4", { class: "card-title mb-0" }, "Détails des informations sur les Créances")
          ], -1)),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("table", _hoisted_37, [
                _cache[30] || (_cache[30] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, "Numéro"),
                    _createElementVNode("th", null, "Montant"),
                    _createElementVNode("th", null, "Date"),
                    _createElementVNode("th", null, "Échéances")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.client?.creances, (creance, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", null, _toDisplayString(creance.id), 1),
                      _createElementVNode("td", null, _toDisplayString(creance.montant), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.format_Date(creance.date)), 1),
                      _createElementVNode("td", null, [
                        (creance.echeances?.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                              _createElementVNode("table", _hoisted_39, [
                                _cache[29] || (_cache[29] = _createElementVNode("thead", null, [
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("th", null, "Date"),
                                    _createElementVNode("th", null, "Montant")
                                  ])
                                ], -1)),
                                _createElementVNode("tbody", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(creance.echeances, (echeance, eIndex) => {
                                    return (_openBlock(), _createElementBlock("tr", { key: eIndex }, [
                                      _createElementVNode("td", null, _toDisplayString(_ctx.format_Date(echeance.date)), 1),
                                      _createElementVNode("td", null, _toDisplayString(echeance.montant), 1)
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_40, "Aucune échéance"))
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_41, [
        _createElementVNode("div", _hoisted_42, [
          _cache[33] || (_cache[33] = _createElementVNode("div", { class: "card-header" }, [
            _createElementVNode("h4", { class: "card-title mb-0" }, "Comptes associés")
          ], -1)),
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("table", _hoisted_45, [
                _cache[32] || (_cache[32] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, "Type de compte"),
                    _createElementVNode("th", null, "Intitulé"),
                    _createElementVNode("th", null, "Solde actuel")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.client?.compteClients, (compte, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", null, _toDisplayString(_ctx.getTypeCompteLabel(compte.typeCompte)), 1),
                      _createElementVNode("td", null, _toDisplayString(compte.intituleCompte), 1),
                      _createElementVNode("td", null, _toDisplayString(compte.soldeActuel), 1)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_46, [
        _createElementVNode("div", _hoisted_47, [
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("h4", null, [
              _cache[35] || (_cache[35] = _createTextVNode("Rapport des échéances ")),
              _createElementVNode("h5", _hoisted_49, [
                _createElementVNode("a", {
                  class: "btn btn-primary btn-sm mt-3",
                  href: "#",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openAddRapportModal && _ctx.openAddRapportModal(...args)), ["prevent"]))
                }, _cache[34] || (_cache[34] = [
                  _createElementVNode("i", { class: "fa fa-lock lh-2 me-8 position-relative top-1" }, null, -1),
                  _createTextVNode(" Ajouter un rapport ")
                ]))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("table", _hoisted_52, [
                _cache[37] || (_cache[37] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, "Échéance (Date)"),
                    _createElementVNode("th", null, "Montant"),
                    _createElementVNode("th", null, "Rapport"),
                    _createElementVNode("th", null, "Date du rapport")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.client?.creances, (creance, cIndex) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: cIndex }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(creance.echeances, (echeance, eIndex) => {
                        return (_openBlock(), _createElementBlock("tr", { key: eIndex }, [
                          _createElementVNode("td", null, _toDisplayString(_ctx.format_Date(echeance.date)), 1),
                          _createElementVNode("td", null, _toDisplayString(echeance.montant), 1),
                          _createElementVNode("td", null, [
                            (echeance.rapports?.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                  _createElementVNode("ul", _hoisted_54, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(echeance.rapports, (rapport, rIndex) => {
                                      return (_openBlock(), _createElementBlock("li", { key: rIndex }, _toDisplayString(rapport.description), 1))
                                    }), 128))
                                  ])
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_55, "Aucun rapport"))
                          ]),
                          _createElementVNode("td", null, [
                            (echeance.rapports?.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                  _createElementVNode("ul", _hoisted_57, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(echeance.rapports, (rapport, rIndex) => {
                                      return (_openBlock(), _createElementBlock("li", { key: rIndex }, _toDisplayString(_ctx.format_Date(rapport.dateRelance)), 1))
                                    }), 128))
                                  ])
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_58, "-"))
                          ])
                        ]))
                      }), 128))
                    ], 64))
                  }), 128)),
                  (!_ctx.hasRapports)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_59, _cache[36] || (_cache[36] = [
                        _createElementVNode("td", {
                          colspan: "4",
                          class: "text-center"
                        }, "Aucun rapport disponible", -1)
                      ])))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.showModal)
      ? (_openBlock(), _createBlock(_component_AddRapportModal, {
          key: 0,
          selectedClient: _ctx.selectedClient,
          onClose: _ctx.closeModal
        }, null, 8, ["selectedClient", "onClose"]))
      : _createCommentVNode("", true)
  ], 64))
}